import { PILLARS } from "../data/mock";
import { Button } from "./ui/button";
import { ArrowRight, Check } from "lucide-react";
import { Link } from "react-router-dom";

const PillarCard = ({ pillar }) => {
  const Icon = pillar.icon;

  return (
    <div
      className="group relative rounded-2xl border bg-white border-[#E0D1BB]/40 hover:border-opacity-60 transition-all duration-500 hover:shadow-xl hover:-translate-y-1 flex flex-col"
      style={{ ["--pillar-color"]: pillar.color }}
    >
      <div className="p-8 lg:p-10 flex-1">
        {/* Header */}
        <div className="flex items-center gap-3 mb-5">
          <div
            className="w-12 h-12 rounded-xl flex items-center justify-center"
            style={{ backgroundColor: pillar.color + "15" }}
          >
            <Icon className="w-6 h-6" style={{ color: pillar.color }} />
          </div>
          <span className="text-xs font-bold tracking-widest uppercase text-[#8A8385]">
            {pillar.tagline}
          </span>
        </div>

        <h3 className="text-xl lg:text-2xl font-bold leading-tight mb-4 text-[#2C2A2B]">
          {pillar.headline}
        </h3>

        <p className="text-sm leading-relaxed mb-6 text-[#6B6567]">
          {pillar.description}
        </p>

        {/* Use Cases */}
        {pillar.useCases && (
          <ul className="space-y-2.5">
            {pillar.useCases.map((uc, i) => (
              <li key={i} className="flex items-start gap-3">
                <Check
                  className="w-4 h-4 mt-0.5 shrink-0"
                  style={{ color: pillar.color }}
                />
                <span className="text-sm text-[#6B6567]">{uc}</span>
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* CTA */}
      <div className="px-8 lg:px-10 pb-8 lg:pb-10">
        <Link to={pillar.href || "#contact"} onClick={() => window.scrollTo(0, 0)}>
          <Button
            className="group/btn transition-all duration-300 font-semibold rounded-xl px-6 py-3 border-2 hover:shadow-lg hover:-translate-y-0.5 bg-white"
            style={{ borderColor: pillar.color + "40", color: pillar.color }}
            variant="outline"
          >
            {pillar.cta}
            <ArrowRight className="ml-2 h-4 w-4 transition-transform duration-300 group-hover/btn:translate-x-1" />
          </Button>
        </Link>
      </div>
    </div>
  );
};

export const PillarsSection = () => {
  return (
    <section id="pillars" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="max-w-2xl mb-16">
          <span className="text-sm font-bold text-[#308795] uppercase tracking-widest mb-3 block">
            Our Solutions
          </span>
          <h2 className="text-3xl lg:text-4xl font-bold text-[#2C2A2B] leading-tight mb-4">
            Four Strategic Pillars for
            <span className="text-[#308795]"> SME Transformation</span>
          </h2>
          <p className="text-[#6B6567] text-lg leading-relaxed">
            We don't just install software. We engineer intelligent systems that
            drive measurable business outcomes.
          </p>
        </div>

        {/* Pillar Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {PILLARS.map((pillar) => (
            <PillarCard key={pillar.id} pillar={pillar} />
          ))}
        </div>
      </div>
    </section>
  );
};
